import { Dispatch, SetStateAction } from 'react';
import { PayRate } from '../../PayRate';

interface PetCareFiltersProps {
  hourlyRate: [number, number];
  setHourlyRate: Dispatch<SetStateAction<[number, number]>>;
}

const PetCareFilters = ({ hourlyRate, setHourlyRate }: PetCareFiltersProps) => {
  return <PayRate hourlyRate={hourlyRate} setHourlyRate={setHourlyRate} />;
};

export { PetCareFilters };
